module.exports = __webpack_public_path__ + "5470f7d85e0b0b20dc4340d2d70945e3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/book.png
// module id = 316
// module chunks = 0